import seedrandom from 'seedrandom';

export function seedShuffle(array, seed) {
  const shuffleArray = [...array];
  const rng = seedrandom(seed);
  let currentIndex = shuffleArray.length;
  let temporaryValue;
  let randomIndex;

  while (currentIndex > 0) {
    randomIndex = Math.floor(rng() * currentIndex);
    currentIndex -= 1;

    temporaryValue = shuffleArray[currentIndex];
    shuffleArray[currentIndex] = shuffleArray[randomIndex];
    shuffleArray[randomIndex] = temporaryValue;
  }

  return shuffleArray;
}
